export const STATUS_ORDER = {
  active: 1,
  accepted: 2,
  payment_pending: 3,
  reserved: 4,
  resolved: 5,
  issue: 6,
  pending: 7,
}